// extracted by mini-css-extract-plugin
export var active = "_c2-2";
export var recordingDot = "_c2-1";
export var recordingIndicator = "_c2-0";